import React, { useRef } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import PromotionalGraphic, { PromotionalGraphicProps } from './PromotionalGraphic';
interface GraphicsCarouselProps {
  graphics: PromotionalGraphicProps[];
  aspectRatio?: 'square' | 'portrait' | 'landscape';
  showOverlay?: boolean;
  viewAllLink?: string;
  viewAllText?: string;
  className?: string;
}
const GraphicsCarousel: React.FC<GraphicsCarouselProps> = ({
  graphics,
  aspectRatio = 'square',
  showOverlay = true,
  viewAllLink,
  viewAllText,
  className
}) => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: -300,
        behavior: 'smooth'
      });
    }
  };
  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: 300,
        behavior: 'smooth'
      });
    }
  };
  // Calculate aspect ratio classes
  const getAspectRatioClass = () => {
    switch (aspectRatio) {
      case 'portrait':
        return 'aspect-[3/4]';
      case 'landscape':
        return 'aspect-[16/9]';
      default:
        return 'aspect-square';
    }
  };
  if (graphics.length === 0) {
    return null;
  }
  return <div className={`relative group ${className || ''}`} data-id="element-1673" data-mp="1w5xuqame7lec">
      <div ref={scrollRef} className="flex overflow-x-auto gap-4 pb-4 snap-x scrollbar-hide" style={{
      scrollbarWidth: 'none',
      msOverflowStyle: 'none'
    }} data-id="element-1674" data-mp="1s4vt5n506x97">
        {graphics.map(graphic => <div key={graphic.id} className={`flex-shrink-0 w-[140px] sm:w-[180px] md:w-[200px] snap-start ${getAspectRatioClass()}`} data-id="element-1675" data-mp="2jtfogbp7wtjy">
            <PromotionalGraphic graphic={graphic} showOverlay={showOverlay} data-id="element-1676" data-mp="2au2c9b9plqvj" />
          </div>)}
      </div>
      {/* Navigation arrows */}
      <button onClick={scrollLeft} className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 bg-white/90 hover:bg-white rounded-full p-2 shadow-md opacity-0 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-200" aria-label="Scroll left" data-id="element-1677" data-mp="zfosoilznxlb">
        <ChevronLeftIcon className="h-6 w-6 text-gray-700" data-id="element-1678" data-mp="rw629raf122p" />
      </button>
      <button onClick={scrollRight} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 bg-white/90 hover:bg-white rounded-full p-2 shadow-md opacity-0 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-200" aria-label="Scroll right" data-id="element-1679" data-mp="ry8ri93qur6d">
        <ChevronRightIcon className="h-6 w-6 text-gray-700" data-id="element-1680" data-mp="mymgm6be1n0q" />
      </button>
    </div>;
};
export default GraphicsCarousel;